import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateServiceWrapper extends TranslateService {
  public override getParsedResult(key: any, interpolateParams?: Record<string, any> | null): any {
    return super.getParsedResult(key, interpolateParams ?? {});
  }
}
